/**
 * Base: Tabs
 */


var ed = ed || {};

ed.tabs = new function(){
    /**
     * Init function
     */
    this.init = function() {
        toggleTab();
    };

    function toggleTab() {
        $('.tabs-navigation__item').on('click', function(){
            var tabs = $(this).closest('.tabs'),
                tabsNavigation = $('.tabs-navigation', tabs),
                tabsPanels = $('.tabs-panels', tabs),
                tab = $('.tab', tabsPanels);

            var target = $(this).data('target');

            if (!$(this).hasClass('active')) {
                // Remove current active state
                $(this).siblings().removeClass('active');
                tab.removeClass('active');

                // Set active
                $(this).addClass('active');
                $(target).addClass('active');
            }
        });
    }
};
